import { render, staticRenderFns } from "./ManagePhoto.vue?vue&type=template&id=8dbd09fc&scoped=true&"
import script from "./ManagePhoto.vue?vue&type=script&lang=js&"
export * from "./ManagePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ManagePhoto.vue?vue&type=style&index=0&id=8dbd09fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbd09fc",
  null
  
)

export default component.exports